import $ from 'jquery';
import { getScrollbarWidth } from '../utils/helpers';
import { URL_PARAMS } from '../utils/constants';
import Keywords from './keywords.class';

const keywords = new Keywords();

const productSelectTitle = () => {
  const firstActiveCheckbox = $('.js-product-list').find(':checked').first();

  if (firstActiveCheckbox.length) {
    const text = firstActiveCheckbox.closest('.checkbox').text().trim();

    $('.js-product-list-toggle-btn').text(text);
  } else {
    $('.js-product-list-toggle-btn').text('Please select...');
  }
};

export default class Filter {
  constructor() {
    this.$filter = $('.js-filter');
    this.$toggleBtn = $('.js-filter-toggle-btn');
    this.$resetBtn = $('.js-filter-reset-btn');
    this.$resetGroupBtn = $('.js-filter-group-reset-btn');
    this.$applyBtn = $('.js-filter-apply-btn');
    this.$controls = $('.js-filter-control');
    this.$filterContent = $('.js-filter-content');
    this.$resultsNumber = $('.js-results-number');
    this.$selectedFiltersCount = $('.js-selected-filters-count');

    this.state = {
      filters: {},
      isFilterOpen: false,
    };

    this.eventHandlers();
    this.preSelect();
  }

  getSelectedCheckboxes() {
    return this.$controls.filter(':checked');
  }

  getVisibleItems() {
    return $('.js-filterable-item').not('.is-hidden');
  }

  toggleNotFoundMessage() {
    if ( $('.js-not-found-text').length ) {
      if ( !this.getVisibleItems().length ) {
        $('.js-not-found-text').removeClass('is-hidden');
      } else {
        $('.js-not-found-text').addClass('is-hidden');
      }
    }
  }

  setResultsNumber() {
    // tabs on publication page
    if ( $('.js-tabs-content').length ) {
      $('.js-tabs-content').each(function () {
        const tabName = $(this).data('tab');
        const visibleItemsCount = $(this).find('.js-filterable-item').not('.is-hidden').length;

        $(`.js-tabs-btn[data-tab="${tabName}"] .js-number`).text(`(${visibleItemsCount})`);
      });
    } else {
      this.$resultsNumber.text(this.getVisibleItems().length);
    }
  }

  preSelect() {
    const productParam = URL_PARAMS.get('Product');
    const taParam = URL_PARAMS.get('therapeutic-area');

    if ( productParam ) {
      const control = $(`.js-filter-control[value=${productParam}]`);
      if (control && control.offset()) {
        const scrollableWrapper = $('.js-product-list .simplebar-content-wrapper');
        const offsetTop = control.offset().top - scrollableWrapper.offset().top;

        control.prop('checked', true).trigger('change');
        scrollableWrapper.scrollTop(offsetTop);

        productSelectTitle();
      }
    }

    if ( taParam ) {
      $(`.js-filter-control[value=${taParam}]`).prop('checked', true).trigger('change');
    }
  }

  open() {
    this.$filterContent.addClass('is-active');

    document.body.style.cssText += `
      padding-right: ${getScrollbarWidth()}px;
      overflow: hidden;
    `;

    this.state.isFilterOpen = true;
  }

  close() {
    this.$filterContent.removeClass('is-active');

    document.body.style.removeProperty('padding-right');
    document.body.style.removeProperty('overflow');

    this.state.isFilterOpen = false;
  }

  toggle() {
    if ( this.state.isFilterOpen ) {
      this.close();
    } else {
      this.open();
    }
  }

  // frontend filter by data-attributes and keywords
  filter() {
    const { filters } = this.state;
    const filterableItems = $('.js-filterable-item');
    const keywordsList = keywords.getList();

    if ( !filterableItems.length ) {
      return;
    }

    filterableItems.each(function () {
      const filterableItem = $(this);
      const text = filterableItem.text().toLowerCase().trim();
      let isHidden = false;

      // by checkboxes
      for (const key in filters) {
        if ( filterableItem.data(key) ) {
          const dataValues = filterableItem.data(key).toLowerCase().split(',');
          const filterValues = filters[key].map(item => item.toLowerCase());

          if ( !dataValues.some(dataValue => filterValues.includes(dataValue)) ) {
            isHidden = true;
          }
        }
      }

      // credit range checkboxes
      if ( 'creditRange' in filters ) {
        let values = [];
        const cardMinValue = filterableItem.data('credit-min');
        const cardMaxValue = filterableItem.data('credit-max');

        // fill array with checkbox values
        filters['creditRange'].forEach(range => {
          const rangeValues = range.split('-');
          const rangeMinValue = +rangeValues[0];
          const rangeMaxValue = +rangeValues[1];

          values.push(rangeMinValue, rangeMaxValue);
        });

        // remove duplicates
        values = [...new Set(values)];

        // get min and max values
        const minValue = Math.min(...values);
        const maxValue = Math.max(...values);

        // toggle filterable cards
        const statement = ( cardMinValue >= minValue && cardMinValue < maxValue )
          || ( cardMaxValue >= minValue && cardMaxValue < maxValue );

        if ( !statement ) {
          isHidden = true;
        }
      }

      // by keywords
      if ( keywordsList.length && !keywordsList.some(keyword => text.includes(keyword.toLowerCase())) ) {
        isHidden = true;
      }

      isHidden
        ? filterableItem.addClass('is-hidden')
        : filterableItem.removeClass('is-hidden');
    });

    this.setResultsNumber();
    this.toggleNotFoundMessage();
  }

  reset() {
    this.$controls.prop('checked', false);
    this.$filter.removeClass('is-active');
    this.$resetBtn.addClass('is-disabled');
    this.$applyBtn.addClass('is-disabled');

    $('.js-filterable-item').removeClass('is-hidden');

    this.setResultsNumber();
    this.toggleNotFoundMessage();
    this.state.filters = {};

    productSelectTitle();
    keywords.clear();
  }

  eventHandlers() {
    // Reset filter
    this.$resetBtn.on('click', (e) => {
      e.preventDefault();

      this.reset();
    });

    // Reset filter group
    this.$resetGroupBtn.on('click', function (e) {
      e.preventDefault();

      $(this).addClass('is-disabled');
      $(this).closest('.js-filter-group').find('.js-filter-control:checked').prop('checked', false).trigger('change');
    });

    // Handle checkboxes change
    this.$controls.on('change customChange', (e) => {
      const { filters } = this.state;
      const $checkbox = $(e.currentTarget);
      const name = $checkbox.attr('name');
      const value = $checkbox.attr('value');
      const isChecked = $checkbox.is(':checked');

      // Product checkboxes
      if ( name === 'Product' ) {
        // Change product select title
        productSelectTitle();

        if ( isChecked ) {
          // uncheck phase checkboxes
          $('.js-phase-list .js-filter-control:checked').prop('checked', false).trigger('change');

          // clear keywords
          keywords.clear();
        }
      }

      if ( isChecked ) {
        filters.hasOwnProperty(name) && filters[name].length
          ? filters[name] = [...new Set([...filters[name], value])]
          : filters[name] = [value];
      } else {
        if ( filters.hasOwnProperty(name) && filters[name].length ) {
          filters[name] = filters[name].filter(
            (item) => item !== value
          );
        }
      }

      if ( filters.hasOwnProperty(name) && !filters[name].length ) {
        delete filters[name];
      }

      // Filter group reset button
      $('.js-filter-group').each(function () {
        const $checkedCheckboxes = $(this).find('.js-filter-control:checked');

        if ( $checkedCheckboxes.length ) {
          $(this).find('.js-filter-group-reset-btn').removeClass('is-disabled');
        } else {
          $(this).find('.js-filter-group-reset-btn').addClass('is-disabled');
        }
      });

      if ( this.getSelectedCheckboxes().length ) {
        this.$filter.addClass('is-active');
        this.$resetBtn.removeClass('is-disabled');
        this.$applyBtn.removeClass('is-disabled');
        this.$selectedFiltersCount.text(this.getSelectedCheckboxes().length);

        this.filter();
      } else {
        this.reset();
      }
    });

    // Apply button on mobile
    this.$applyBtn.on('click', (e) => {
      e.preventDefault();

      this.close();
    });

    // Toggle filter on mobile
    this.$toggleBtn.on('click', (e) => {
      e.preventDefault();

      this.toggle();
    });

    // Keywords handlers
    $(document).on('click', '.js-remove-keyword-btn', () => {
      this.filter();
    });

    keywords.$form.on('submit', () => {
      this.filter();
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/project/filter.class.js